<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p3"><span class="sz">To the memory of my maternal grandfather,</span></p>
<p class="p3"><span class="sz">Charles Columbus Wentz:</span></p>
<p class="p3"><span class="sz">Born in the worst era of this nation’s past,</span></p>
<p class="p3"><span class="sz">named for a Negro slave; cotton grower,</span></p>
<p class="p3"><span class="sz">cattleman, and latter-day empresario;</span></p>
<p class="p3"><span class="sz">he had always courage.</span></p>
<p class="p2"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?4f6309ba